module.exports = __webpack_public_path__ + "assets/loops-tree-folder.2a51d70c.svg";